import { getScreenNameAuthenticated, getUserAuthenticated } from "../../utils/auth/Auth-utils";
import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerBeneficiosProducto = (codigosBeneficio) => {
    let atributos = [{ campo: 'codigosBeneficio', valor: codigosBeneficio }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_BENEFICIOS_POR_PRODUCTO, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const obtenerTextosLegales = (codigoProducto) => {
    let atributos = [{ campo: 'codProducto', valor: codigoProducto }];
    return FuncionesServices.procesarRespuestraCloud({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_LISTAR_TEXTOS_LEGALES_PRODUCTOS, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'            : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'          : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'         : getScreenNameAuthenticated()
        })
    })
}

export const obtenerConfiguracionProducto = (codigoProducto, codigoSubProducto) => {
    let atributos = [
        { campo: 'codigoProducto', valor: codigoProducto },
        { campo: 'codigoSubProducto', valor: codigoSubProducto }
      ]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PRODUCTO_CONFIGURACION, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const listarProductos = (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_PRODUCTOS_X_IDSOLICITUDMULTIPLE, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}